module.exports = __webpack_public_path__ + "static/img/beijing2.04ccf30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/lunbo/beijing2.png
// module id = I6Iq
// module chunks = 5